// agenda.js (cliente) - VERSIÓN COMPLETA CORREGIDA
import { API_BASE } from '../utils/helpers';

const API = `${API_BASE}/api/agenda`;
// const API = 'http://localhost:4000/api/agenda'; // Local (requiere backend local)

async function handleResponse(res) {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let errorMessage = text;
    let errorDetails = null;
    
    try {
      const json = JSON.parse(text);
      errorMessage = json.error || json.message || text;
      errorDetails = json.detalle || json.details || null;
      
      console.error('❌ Error del servidor:', {
        status: res.status,
        message: errorMessage,
        detalle: errorDetails
      });
    } catch (e) {
      console.error('❌ Error del servidor (no JSON):', text);
    }
    
    const error = new Error(errorMessage || `Error HTTP ${res.status}`);
    error.status = res.status;
    error.response = text;
    error.details = errorDetails;
    throw error;
  }
  return res.json();
}

async function http(method, url, body) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    }
  };

  if (body) options.body = JSON.stringify(body);

  const res = await fetch(url, options);
  return handleResponse(res);
}

async function httpUrlEncoded(method, url, bodyObj) {
  const params = new URLSearchParams();
  Object.entries(bodyObj || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) params.append(k, String(v));
  });
  const options = {
    method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params.toString()
  };
  const res = await fetch(url, options);
  return handleResponse(res);
}

// Admin: horario semanal
export const getHorarioSemanal = () => http('GET', `${API}/semanal`);

// Normaliza una hora a formato HH:mm (sin segundos)
const toHHMM = (v) => {
  if (v == null || v === '') return null;
  const s = String(v).trim();
  if (s === '') return null;

  // Aceptar HH:mm directamente si es válido
  const mmMatch = s.match(/^(\d{1,2}):(\d{2})$/);
  if (mmMatch) {
    const hh = parseInt(mmMatch[1], 10);
    const mm = parseInt(mmMatch[2], 10);
    if (!isNaN(hh) && !isNaN(mm) && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59) {
      return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
    }
  }

  // Si viene HH:mm:ss, reducir a HH:mm validando rangos
  const m = s.match(/^(\d{1,2}):(\d{2}):(\d{2})$/);
  if (m) {
    const hh = parseInt(m[1], 10);
    const mm = parseInt(m[2], 10);
    const ss = parseInt(m[3], 10);
    if (!isNaN(hh) && !isNaN(mm) && !isNaN(ss) && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59 && ss >= 0 && ss <= 59) {
      return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
    }
  }

  // Intentar parsear objetos Date o iso
  try {
    const d = new Date(s);
    if (!isNaN(d.getTime())) {
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      return `${hh}:${mm}`;
    }
  } catch {}

  return null;
};

// Convierte HH:mm o HH:mm:ss a HH:mm:ss (con segundos)
const toHHMMSS = (v) => {
  if (v == null || v === '') return null;
  const s = String(v).trim();
  const m1 = s.match(/^(\d{1,2}):(\d{2})$/);
  if (m1) {
    const hh = parseInt(m1[1], 10);
    const mm = parseInt(m1[2], 10);
    if (!isNaN(hh) && !isNaN(mm) && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59) {
      return `${String(hh).padStart(2,'0')}:${String(mm).padStart(2,'0')}:00`;
    }
  }
  const m2 = s.match(/^(\d{1,2}):(\d{2}):(\d{2})$/);
  if (m2) {
    const hh = parseInt(m2[1], 10);
    const mm = parseInt(m2[2], 10);
    const ss = parseInt(m2[3], 10);
    if (!isNaN(hh) && !isNaN(mm) && !isNaN(ss) && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59 && ss >= 0 && ss <= 59) {
      return `${String(hh).padStart(2,'0')}:${String(mm).padStart(2,'0')}:${String(ss).padStart(2,'0')}`;
    }
  }
  return null;
};

const toAMPM = (v) => {
  const s = toHHMM(v);
  if (!s) return null;
  const [hh, mm] = s.split(':').map(n => parseInt(n, 10));
  const suffix = hh >= 12 ? 'PM' : 'AM';
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${String(h12).padStart(2,'0')}:${String(mm).padStart(2,'0')} ${suffix}`;
};

const toISODateTime = (v, withZ=false, withMillis=false) => {
  const ss = toHHMMSS(v);
  if (!ss) return null;
  const base = `1970-01-01T${ss}${withMillis ? '.000' : ''}`;
  return withZ ? `${base}Z` : base;
};

// CORREGIDO: Cambiar HoraInicio/HoraFin por Inicio/Fin
export async function upsertDiaSemanal(payload) {
  // Preparar variantes robustas para máxima compatibilidad con servidores que validan distinto
  const dia = Number(payload.DiaSemana);
  const activoBool = payload.Activo !== undefined ? !!payload.Activo : true;

  const hhmm = toHHMM(payload.Inicio);
  const hhmmEnd = toHHMM(payload.Fin);
  const hhmmss = toHHMMSS(payload.Inicio);
  const hhmmssEnd = toHHMMSS(payload.Fin);

  if (!hhmm && !hhmmss) {
    throw new Error(`El parámetro Inicio es inválido. Valor recibido: "${payload.Inicio}".`);
  }
  if (!hhmmEnd && !hhmmssEnd) {
    throw new Error(`El parámetro Fin es inválido. Valor recibido: "${payload.Fin}".`);
  }

  const to7 = (s) => {
    const m1 = String(s).match(/^(\d{2}):(\d{2}):(\d{2})$/);
    if (m1) return `${m1[1]}:${m1[2]}:${m1[3]}.0000000`;
    const m2 = String(s).match(/^(\d{2}):(\d{2})$/);
    if (m2) return `${m2[1]}:${m2[2]}:00.0000000`;
    return null;
  };

  const ampm = toAMPM(payload.Inicio);
  const ampmEnd = toAMPM(payload.Fin);
  const iso = toISODateTime(payload.Inicio, false, false);
  const isoZ = toISODateTime(payload.Inicio, true, false);
  const isoMs = toISODateTime(payload.Inicio, false, true);
  const isoMsZ = toISODateTime(payload.Inicio, true, true);
  const isoEnd = toISODateTime(payload.Fin, false, false);
  const isoEndZ = toISODateTime(payload.Fin, true, false);
  const isoEndMs = toISODateTime(payload.Fin, false, true);
  const isoEndMsZ = toISODateTime(payload.Fin, true, true);

  const candidates = [
    // 1) ISO con Z (parece ser lo que devuelve el backend)
    { DiaSemana: dia, Inicio: isoZ, Fin: isoEndZ, Activo: activoBool },
    // 2) ISO con milisegundos y Z
    { DiaSemana: dia, Inicio: isoMsZ, Fin: isoEndMsZ, Activo: activoBool },
    // 3) ISO local (sin Z)
    { DiaSemana: dia, Inicio: iso, Fin: isoEnd, Activo: activoBool },
    // 4) ISO local con milisegundos
    { DiaSemana: dia, Inicio: isoMs, Fin: isoEndMs, Activo: activoBool },
    // 5) Inicio/Fin HH:mm:ss
    { DiaSemana: dia, Inicio: hhmmss, Fin: hhmmssEnd, Activo: activoBool },
    // 6) Inicio/Fin HH:mm
    { DiaSemana: dia, Inicio: hhmm, Fin: hhmmEnd, Activo: activoBool },
    // 7) Inicio/Fin HH:mm:ss.0000000 (precision 7)
    { DiaSemana: dia, Inicio: to7(hhmmss || hhmm), Fin: to7(hhmmssEnd || hhmmEnd), Activo: activoBool },
    // 8) Legacy HoraInicio/HoraFin + Inicio/Fin en precision 7
    { DiaSemana: dia, Inicio: to7(hhmmss || hhmm), Fin: to7(hhmmssEnd || hhmmEnd), HoraInicio: to7(hhmmss || hhmm), HoraFin: to7(hhmmssEnd || hhmmEnd), Activo: activoBool },
    // 9) Activo como 1/0
    { DiaSemana: dia, Inicio: hhmmss || hhmm, Fin: hhmmssEnd || hhmmEnd, Activo: activoBool ? 1 : 0 },
    // 10) AM/PM
    { DiaSemana: dia, Inicio: ampm, Fin: ampmEnd, Activo: activoBool },
    // 11) Duplicado con claves minúsculas además de mayúsculas
    { DiaSemana: String(dia), Inicio: hhmmss || hhmm, Fin: hhmmssEnd || hhmmEnd, Activo: String(activoBool), diaSemana: String(dia), inicio: hhmmss || hhmm, fin: hhmmssEnd || hhmmEnd, activo: String(activoBool) },
  ].filter(b => b.Inicio && b.Fin);

  let lastError = null;
  // Intentos con JSON
  for (let i = 0; i < candidates.length; i++) {
    const body = candidates[i];
    console.log(`API DEBUG -> upsertDiaSemanal intento ${i+1} (JSON):`, JSON.parse(JSON.stringify(body)));
    try {
      return await http('POST', `${API}/semanal`, body);
    } catch (err) {
      lastError = err;
      const msg = (err && err.message) ? err.message.toLowerCase() : '';
      if (!(msg.includes('invalid time') || err.status >= 400)) {
        break;
      }
      console.warn(`⚠️ Falló intento ${i+1} (JSON): ${err.message}`);
    }
  }

  // Intentos con x-www-form-urlencoded
  for (let i = 0; i < candidates.length; i++) {
    const body = candidates[i];
    const urlBody = { ...body };
    // Convertir boolean a string por si el server lo requiere
    if (typeof urlBody.Activo === 'boolean') urlBody.Activo = urlBody.Activo ? 'true' : 'false';
    console.log(`API DEBUG -> upsertDiaSemanal intento ${i+1} (FORM):`, JSON.parse(JSON.stringify(urlBody)));
    try {
      return await httpUrlEncoded('POST', `${API}/semanal`, urlBody);
    } catch (err) {
      lastError = err;
      const msg = (err && err.message) ? err.message.toLowerCase() : '';
      if (!(msg.includes('invalid time') || err.status >= 400)) {
        break;
      }
      console.warn(`⚠️ Falló intento ${i+1} (FORM): ${err.message}`);
    }
  }
  throw lastError || new Error('No fue posible guardar el horario');
}

// Admin: gestión de bloques de tiempo (NUEVO SISTEMA)
export const getBloqueos = () => http('GET', `${API}/bloqueos`);
export const createBloqueo = async (payload) => {
  // Normalizar múltiples variantes por compatibilidad con SQL TIME
  const baseIni = toHHMMSS(payload.Inicio ?? payload.BloqueInicio ?? payload.inicio);
  const baseFin = toHHMMSS(payload.Fin ?? payload.BloqueFin ?? payload.fin);
  const to7 = (s) => {
    if (!s) return null;
    const m = String(s).match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) return null;
    const hh = m[1]; const mm = m[2]; const ss = m[3] || '00';
    return `${hh}:${mm}:${ss}.0000000`;
  };
  const isoZ = (s) => {
    if (!s) return null;
    const hhmmss = toHHMMSS(s);
    if (!hhmmss) return null;
    return `1970-01-01T${hhmmss}.000Z`;
  };

  const dia = Number(payload.DiaSemana ?? payload.diaSemana);
  const candidates = [
    { DiaSemana: dia, Inicio: baseIni, Fin: baseFin, Motivo: payload.Motivo || '' },
    { DiaSemana: dia, Inicio: to7(baseIni), Fin: to7(baseFin), Motivo: payload.Motivo || '' },
    { DiaSemana: dia, Inicio: isoZ(baseIni), Fin: isoZ(baseFin), Motivo: payload.Motivo || '' },
    // con claves alternativas
    { DiaSemana: dia, BloqueInicio: to7(baseIni), BloqueFin: to7(baseFin), Motivo: payload.Motivo || '' },
  ].filter(b => (b.Inicio || b.BloqueInicio) && (b.Fin || b.BloqueFin));

  let lastErr = null;
  // JSON first
  for (let i = 0; i < candidates.length; i++) {
    const body = candidates[i];
    console.log(`API DEBUG -> createBloqueo intento ${i+1} (JSON):`, JSON.parse(JSON.stringify(body)));
    try {
      return await http('POST', `${API}/bloqueos`, body);
    } catch (err) {
      lastErr = err;
      const msg = (err && err.message || '').toLowerCase();
      if (!(msg.includes('invalid time') || err.status >= 400)) break;
      console.warn(`⚠️ Falló intento ${i+1} (JSON): ${err.message}`);
    }
  }
  // FORM fallback
  for (let i = 0; i < candidates.length; i++) {
    const body = candidates[i];
    const urlBody = { ...body };
    if (urlBody.Inicio == null && urlBody.BloqueInicio != null) {
      urlBody.Inicio = urlBody.BloqueInicio; delete urlBody.BloqueInicio;
    }
    if (urlBody.Fin == null && urlBody.BloqueFin != null) {
      urlBody.Fin = urlBody.BloqueFin; delete urlBody.BloqueFin;
    }
    console.log(`API DEBUG -> createBloqueo intento ${i+1} (FORM):`, JSON.parse(JSON.stringify(urlBody)));
    try {
      return await httpUrlEncoded('POST', `${API}/bloqueos`, urlBody);
    } catch (err) {
      lastErr = err;
      const msg = (err && err.message || '').toLowerCase();
      if (!(msg.includes('invalid time') || err.status >= 400)) break;
      console.warn(`⚠️ Falló intento ${i+1} (FORM): ${err.message}`);
    }
  }
  throw lastErr || new Error('No fue posible crear el bloqueo');
};
export const deleteBloqueo = (id) => http('DELETE', `${API}/bloqueos/${id}`);

// Cliente: disponibilidad
export const getDisponibilidad = (fecha, productoId) =>
  http('POST', `${API}/disponibilidad`, { Fecha: fecha, ProductoId: productoId });

// FUNCIONES DE EXCEPCIÓN (PARA MANTENER COMPATIBILIDAD)
export const getExcepciones = (from, to) => {
  return getBloqueos();
};

export const createExcepcion = (payload) => {
  const bloquePayload = {
    DiaSemana: getDiaSemanaFromFecha(payload.Fecha),
    Inicio: payload.Inicio,          // ✅ Cambiado BloqueInicio por Inicio
    Fin: payload.Fin,                // ✅ Cambiado BloqueFin por Fin
    Motivo: payload.Motivo || 'Excepción'
  };
  return createBloqueo(bloquePayload);
};

export const updateExcepcion = (id, payload) => {
  return deleteBloqueo(id).then(() => {
    const bloquePayload = {
      DiaSemana: getDiaSemanaFromFecha(payload.Fecha),
      Inicio: payload.Inicio,        // ✅ Cambiado BloqueInicio por Inicio
      Fin: payload.Fin,              // ✅ Cambiado BloqueFin por Fin
      Motivo: payload.Motivo || 'Excepción'
    };
    return createBloqueo(bloquePayload);
  });
};

export const deleteExcepcion = (id) => {
  return deleteBloqueo(id);
};

// Helper para obtener día de la semana desde fecha
function getDiaSemanaFromFecha(fecha) {
  const date = new Date(fecha);
  let dia = date.getDay();
  return dia === 0 ? 7 : dia;
}
